// Shop — $19 paid digital products, Stripe-gated, SendGrid delivery of signed PDF link.

export const SHOP_PRODUCTS = {
  "authority-gap-playbook": {
    slug: "authority-gap-playbook",
    productKey: "authority_gap_playbook",
    name: "The Authority Gap Playbook",
    blurb: "The 60-page playbook that walks through why credentialed experts lose online and how AuthorityOS closes the gap.",
    pages: 60,
    type: "Playbook",
    accent: "#FF6575",
    priceLabel: "$19",
    cta: "Get the Playbook — $19",
    delivers: [
      "Why the smartest people in your industry stay invisible",
      "The 7 Authority Assets framework",
      "Sequencing — what to build in what order",
      "Compliance-safe language for credentialed niches",
      "Three end-to-end case walkthroughs",
    ],
  },
  "authorityos-starter-guide": {
    slug: "authorityos-starter-guide",
    productKey: "authorityos_starter_guide",
    name: "AuthorityOS Starter Guide",
    blurb: "Your first 30 days inside the framework — exactly what to build, in what order, and why.",
    pages: 28,
    type: "Guide",
    accent: "#3aab5a",
    priceLabel: "$19",
    cta: "Get the Starter Guide — $19",
    delivers: [
      "30-day build calendar",
      "Asset prioritization scoring",
      "Sample positioning statements",
      "Quick-start templates",
      "What to skip in your first 90 days",
    ],
  },
  "content-engine-blueprint": {
    slug: "content-engine-blueprint",
    productKey: "content_engine_blueprint",
    name: "Content Engine Blueprint",
    blurb: "The complete content production system used across all six AuthorityOS labs.",
    pages: 34,
    type: "Blueprint",
    accent: "#9a6adb",
    priceLabel: "$19",
    cta: "Get the Blueprint — $19",
    delivers: [
      "Pillar-and-cluster architecture",
      "Editorial calendar template",
      "12-asset repurpose matrix",
      "Quality bar scorecard",
      "Compliance overlay rules",
    ],
  },
  "ai-authority-toolkit": {
    slug: "ai-authority-toolkit",
    productKey: "ai_authority_toolkit",
    name: "AI Authority Toolkit",
    blurb: "How to deploy an AI assistant trained on your expertise — prompts, guardrails, and disclosure templates.",
    pages: 26,
    type: "Toolkit",
    accent: "#3a9acb",
    priceLabel: "$19",
    cta: "Get the Toolkit — $19",
    delivers: [
      "Role + framework prompt patterns",
      "Compliance overlay templates",
      "Refusal pattern library",
      "Lead capture integration playbook",
      "Production deployment checklist",
    ],
  },
};

export const SHOP_LIST = Object.values(SHOP_PRODUCTS);
